import { Controller } from '@hotwired/stimulus'
import { api, PriorityOption } from '../../api'

export default class PriorityController extends Controller<HTMLElement> {
  declare submissionIdValue: string

  static values = {
    submissionId: String,
  }

  // Public methods

  update(event: Event & { params: { value: PriorityOption } }) {
    const priority = event.params.value as PriorityOption

    api.submissions.updatePriority({ priority, submissionId: this.submissionIdValue })
  }
}
